import Backdraft from "backdraft-app/src/backdraft";
import _ from "underscore";
import $ from "jquery";

import "sparks/invoca_app";

import ExceptionHandling from "shared/logging/exception_handling";

Backdraft.plugin("StatusChangeReasonModal", plugin => {
  const DEFAULT_JST_DELIMS = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  plugin.initializer(app => {
    app.installPlugin("InvocaApp");

    app.view.modal("StatusChangeReasonModal", {

      defaultTemplate: _.template('<div><%= confirmationMessage %></div>', null, DEFAULT_JST_DELIMS),

      declineTemplate: _.template(`
        <% if (this.bulkAction) { %><div><%= confirmationMessage %></div><br/><% } %>
        <% if (this.displayStatusChangeReasonForm) { %>
        <div>
        Please provide an explanation to include in the email to the applicant:
        </div>
        <br/>
        <textarea rows="6" cols="40" class="form-control"></textarea>
        <% } %>
      `, null, DEFAULT_JST_DELIMS),

      suspendTemplate: _.template(`
        <% if (this.bulkAction) { %><div><%= confirmationMessage %></div><br/><% } %>
        <% if (this.displayStatusChangeReasonForm) { %>
        <div>
          All calls to the <%= nameForOrganization(true, false, true, true) %> campaigns will play a suspended prompt
          and commissions will not be paid. 
          <br/>
          <br/> We will send an email notification to the <%= nameForOrganization(true, false, false, true) %><% if (organizationType === "Advertiser") { %>
            and their joined <%= nameForAffiliate %>
            <% } %>. Please provide an explanation to include in the email to the <%= nameForOrganization(true, false, false, true) %>:
        </div>
        <br/>
        <textarea rows="6" cols="40" class="form-control"></textarea>
        <% } %>
      `, null, DEFAULT_JST_DELIMS),

      archiveTemplate: _.template(`
        <% if (this.bulkAction) { %><div><%= confirmationMessage %></div><br/><% } %>
        <% if (this.displayStatusChangeReasonForm) { %>
        <div>
          The following <%= nameForOrganization(true, true, false, true) %> have active campaigns:<br/>
          &nbsp;&nbsp;<%= orgsWithActiveCampaigns.join("<br/>&nbsp;&nbsp;") %>
          <br/>
          <br/>
          All of their active campaigns will be paused, notifications will be sent to their joined <%= nameForAffiliate %>, and commissions and call traffic will stop.
          <br/>
          <br/>
          <strong>Are you sure you want to archive these <%= nameForOrganization(true, true, false, true) %>?</strong>
        </div>
        <% } %>
      `, null, DEFAULT_JST_DELIMS),

      initialize(options) {
        if (options.approvalStatus && !_.contains(["Approved", "Declined", "Suspended", "Archived"], options.approvalStatus)) {
          throw new Error(`Invalid approvalStatus ${options.approvalStatus}`);
        }
        this.approvalStatus = options.approvalStatus;
        this.saveCallback = options.saveCallback;
        this.organizationType = options.organizationType;
        this.orgsWithActiveCampaigns = options.orgsWithActiveCampaigns || [];
        this.displayStatusChangeReasonForm = options.displayStatusChangeReasonForm;
        this.bulkAction = options.bulkAction;
        this.confirmationMessage = options.confirmationMessage;
        this.plural = options.plural;

        _.bindAll(this, "_friendlyOrganizationName");
      },

      title() {
        switch (this.approvalStatus) {
        case "Approved":
          return `Approve ${this._friendlyOrganizationName(false, this.plural, false, true)}`;
        case "Declined":
          return `Decline Application${this.plural ? "s" : ""}`;
        case "Suspended":
          return `Suspend ${this._friendlyOrganizationName(false, this.plural, false, true)}`;
        case "Archived":
          return `Archive ${this._friendlyOrganizationName(false, this.plural, false, true)}`;
        default:
          if (this.confirmationMessage) {
            return "Confirm bulk action";
          } else {
            ExceptionHandling.logError("Invalid approvalStatus");
          }
        }
      },

      body() {
        switch (this.approvalStatus) {
        case "Declined":
          return this.declineTemplate({
            confirmationMessage: this.confirmationMessage
          });
        case "Suspended":
          return this.suspendTemplate({
            organizationType: this.organizationType,
            nameForOrganization: this._friendlyOrganizationName,
            nameForAffiliate: app.nameForAffiliate(true, true, false, true),
            confirmationMessage: this.confirmationMessage
          });
        case "Archived":
          return this.archiveTemplate({
            organizationType: this.organizationType,
            nameForOrganization: this._friendlyOrganizationName,
            nameForAffiliate: app.nameForAffiliate(true, true, false, true),
            orgsWithActiveCampaigns: this.orgsWithActiveCampaigns,
            confirmationMessage: this.confirmationMessage
          });
        default:
          if (this.confirmationMessage) {
            return this.defaultTemplate({
              confirmationMessage: this.confirmationMessage
            });
          } else {
            ExceptionHandling.logError("Invalid approvalStatus");
          }
        }
      },

      buttons() {
        const primaryButtonText = this._primaryButtonText(this.approvalStatus);

        const self = this;
        const approvalStatus = this.approvalStatus;
        return [
          {
            text: "Cancel",
            className: "btn-secondary",
            close: true
          },
          {
            text: primaryButtonText,
            className: "btn-primary",
            click(e) {
              const rejectReason = $.trim(self.$("textarea").val());
              if (self.displayStatusChangeReasonForm && rejectReason === "" && approvalStatus !== "Archived") {
                self.setError("Please enter a message.");
              } else {
                if (rejectReason !== "") {
                  self.saveCallback({
                    reject_reason: rejectReason
                  });
                } else {
                  self.saveCallback();
                }
                self.setError(null);
                self.close();
                return false;
              }
            }
          }
        ];
      },

      _primaryButtonText(status) {
        switch (status) {
        case "Approved":
          return `Approve ${this._friendlyOrganizationName(false, this.plural, false, true)}`;
        case "Declined":
          return `Decline Application${this.plural ? "s" : ""}`;
        case "Suspended":
          return `Suspend ${this._friendlyOrganizationName(false, this.plural, false, true)}`;
        case "Archived":
          return "Archive";
        default:
          if (this.confirmationMessage) {
            return "Ok";
          } else {
            ExceptionHandling.logError("Invalid approvalStatus");
          }
        }
      },

      _friendlyOrganizationName(...args) {
        if (this.organizationType === "Advertiser") {
          return app.nameForAdvertiser.apply(app, args);
        } else if (this.organizationType === "Affiliate") {
          return app.nameForAffiliate.apply(app, args);
        }
      }
    });

    app.Views.StatusChangeReasonModal.display = options => {
      if (!options.row || !options.config || !options.models || !options.proceed || !options.organizationType || !options.swapOrganizationType) {
        throw new Error("Not all options passed.");
      }

      const row = options.row;
      const config = options.config;
      let models = options.models;
      const proceed = options.proceed;
      const organizationType = options.organizationType;
      const swapOrganizationType = options.swapOrganizationType;
      const bulkAction = (options.bulkAction || false);
      const newStatus = config.params.approval_status;

      if (!_.isArray(models)) {
        models = [models];
      }

      let confirmText;
      switch (config.text) {
      case "Approve":
        confirmText = "approve";
        break;
      case "Decline":
        confirmText = "decline";
        break;
      case "Suspend":
        confirmText = "suspend";
        break;
      case "Archive":
        confirmText = "archive";
        break;
      case `Change to ${app[`nameFor${swapOrganizationType}`](true, false, false, true)}`:
        confirmText = "swap";
        break;
      default:
        ExceptionHandling.logError("Invalid status");
      }

      const plural = models.length > 1;
      let confirmationMessage = `Are you sure you want to ${confirmText} ${models.length} ${app[`nameFor${organizationType}`](true, plural, false, true)}`;
      if (confirmText === "swap") {
        confirmationMessage += ` to ${app[`nameFor${swapOrganizationType}`](true, plural, false, true)}`;
      }
      confirmationMessage += "?";

      const orgsWithActiveCampaigns = [];
      _.each(models, model => {
        if (model.get("active_campaigns") > 0) {
          orgsWithActiveCampaigns.push(model.escape("name"));
        }
      });

      const displayStatusChangeReasonForm = (newStatus === "Declined" || newStatus === "Suspended" || (newStatus === "Archived" && organizationType === "Advertiser" && orgsWithActiveCampaigns.length > 0));
      const anyStatusChanged = _.any(models, model => model.get("approval_status") !== newStatus);
      const displayModal = bulkAction ? true : anyStatusChanged && displayStatusChangeReasonForm;

      if (displayModal) {
        let statusChangeReasonModal = row.child("statusChangeReasonModal");
        statusChangeReasonModal && statusChangeReasonModal.close();
        statusChangeReasonModal = new app.Views.StatusChangeReasonModal({
          approvalStatus: newStatus,
          saveCallback: proceed,
          organizationType,
          orgsWithActiveCampaigns,
          displayStatusChangeReasonForm,
          bulkAction,
          confirmationMessage,
          plural
        });
        row.child("statusChangeReasonModal", statusChangeReasonModal.render());
      } else {
        proceed({});
      }
    };
  });
});
